import { DefaultError, useQuery } from '@tanstack/react-query';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import {
  ICountry,
  IEnumNameId,
  IPredefinedSalesChannel,
  ISettlementMethod,
  IStatementTemplate,
} from './types';

export const useGetCountries = (enabled = true) => {
  const { responseHandler } = useResponseHandler();
  return useQuery<ICountry[], DefaultError>({
    queryKey: ['countries'],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: 'Enum/Countries',
      });

      return responseHandler(response, {
        groupName: 'useGetCountries',
      });
    },
    staleTime: 60 * 60 * 1000,
    enabled,
  });
};

export const useGetPredefindedSalesChannels = (
  magellanAccountId?: string,
  enabled = true
) => {
  const { responseHandler } = useResponseHandler();
  const scoped = magellanAccountId !== undefined;

  return useQuery<IPredefinedSalesChannel[], DefaultError>({
    queryKey: scoped
      ? ['PredefinedSalesChannel', magellanAccountId]
      : ['PredefinedSalesChannel'],
    enabled: enabled && (!scoped || !!magellanAccountId),
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: 'Enum/PredefinedSalesChannel',
        params:
          scoped && magellanAccountId
            ? { magellanAccountId }
            : undefined,
      });

      return responseHandler(response, {
        groupName: 'useGetPredefindedSalesChannels',
      });
    },
    staleTime: 60 * 60 * 1000,
  });
};
export const useGetSettlementMethods = (enabled = true) => {
  const { responseHandler } = useResponseHandler();
  return useQuery<ISettlementMethod[], DefaultError>({
    queryKey: ['settlement-methods'],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: 'Enum/SettlementMethods',
      });

      return responseHandler(response, {
        groupName: 'useGetSettlementMethods',
      });
    },
    staleTime: 60 * 60 * 1000,
    enabled,
  });
};
export const useGetStatementTemplates = (enabled = true) => {
  const { responseHandler } = useResponseHandler();
  return useQuery<IStatementTemplate[], DefaultError>({
    queryKey: ['statement-template-types'],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: 'Enum/StatementTemplateTypes',
      });

      return responseHandler(response, {
        groupName: 'useGetStatementTemplates',
      });
    },
    staleTime: 60 * 60 * 1000,
    enabled,
  });
};

export const useGetStatementTemplateTypes = useGetStatementTemplates;

export const useGetYouTubeContentIdAuthorizationStatuses = (
  enabled = true
) => {
  const { responseHandler } = useResponseHandler();

  return useQuery<IEnumNameId[], DefaultError>({
    queryKey: ['youtube-content-id-authorization-statuses'],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: 'Enum/YouTubeContentIdAuthorizationStatuses',
      });

      return responseHandler(response, {
        groupName: 'useGetYouTubeContentIdAuthorizationStatuses',
      });
    },
    staleTime: 60 * 60 * 1000,
    enabled,
  });
};
